import { render, staticRenderFns } from "./ASelecionar-modulo.vue?vue&type=template&id=698f12d2"
import script from "./ASelecionar-modulo.vue?vue&type=script&lang=js"
export * from "./ASelecionar-modulo.vue?vue&type=script&lang=js"
import style0 from "./ASelecionar-modulo.vue?vue&type=style&index=0&id=698f12d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports